import color from 'atoms/colors/colors';

import Flex from 'quarks/Flex';
import Heading from 'quarks/Heading';
import Image from 'quarks/Image';
import Link from 'quarks/Link';
import Text from 'quarks/Text';

import type { ContentfulAsset, Maybe } from 'graphqlTypes';
import type { FC } from 'react';

interface CustomerStoryCardProps {
  logo?: Maybe<ContentfulAsset>;
  name?: Maybe<string>;
  heading?: Maybe<string>;
  slug?: Maybe<string>;
  logoShouldNotFilterColor?: Maybe<boolean>;
  tabIndex?: number;
}

const CustomerStoryCard: FC<CustomerStoryCardProps> = ({
  slug,
  logo,
  name,
  heading,
  tabIndex,
  logoShouldNotFilterColor = false,
}) => (
  <Link
    href={`/our-customers/${slug}`}
    flexDirection="column"
    textDecoration="none"
    hover={{
      backgroundColor: 'gray-100',
      boxShadow: `0 0 0 16px ${color.gray[100]}`,
    }}
    justifyContent="center"
    display="flex"
    width="calc(100vw - 32px)"
    sm={{ width: 'calc(100vw - 48px)' }}
    lg={{ width: '100%' }}
    tabIndex={tabIndex}
  >
    {logo && (
      <Flex
        backgroundColor="primary-500"
        paddingAll={48}
        marginBottom={16}
        height="215px"
        alignItems="center"
        justifyContent="center"
      >
        <Image
          image={logo}
          alt={name ? `${name}-logo` : ''}
          white={!logoShouldNotFilterColor}
          width="100%"
          objectFit="contain"
          height="auto"
          maxHeight="100%"
          css="& img { object-fit: contain !important; }" // gatsby-plugin-image does not seem to be passing down objectFit correctly - cover is always set as inline style
        />
      </Flex>
    )}
    {heading && (
      <Heading
        as="h2"
        marginBottom={8}
        textColor="common-black"
        textStyle="xs"
        fontSize="textXl"
        xl={{ fontSize: 'displayXs' }}
      >
        {heading}
      </Heading>
    )}
    <Text textColor="primary-500" fontSize="textMd" fontWeight="bold" marginTop="auto">
      Read the story
    </Text>
  </Link>
);

export default CustomerStoryCard;
